import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/users/$id')({
  component: UserDetailPage,
  loader: async ({ params }) => {
    return {
      user: {
        id: params.id,
        email: 'Loading...',
      },
    };
  },
});

function UserDetailPage() {
  const { id } = Route.useParams();
  const { user } = Route.useLoaderData();
  
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold mb-2">User Details</h2>
        <p className="text-muted-foreground">User ID: {id}</p>
      </div>
      
      <div className="border rounded-lg p-4">
        <p className="text-sm text-muted-foreground">
          User details will be implemented here. Email: {user.email}
        </p>
      </div>
    </div>
  );
}

